class DateFunctions {
    static currentDateYYYYMMDD () {
        return DateFunctions.datetoYYYYMMDD(new Date());
    }

    static currentDatePlus10YYYYMMDD () {
        const date = new Date();
        date.setYear(date.getFullYear() + 10);
        return DateFunctions.datetoYYYYMMDD(date);
    }

    static datetoYYYYMMDD (date) {
        const dag = date.getDate();
        const maand = date.getMonth() + 1;
        const jaar = date.getFullYear();
        return `${jaar}-${maand}-${dag} `;
    }

    static datetoYYYYMMDDZero (date) {
        const dag = (`0${date.getDate()}`).slice(-2);
        const maand = (`0${date.getMonth() + 1}`).slice(-2);
        const jaar = date.getFullYear();
        return `${jaar}-${maand}-${dag}`;
    }

    static datetoDDMMYYYY (datestring) {
        const splitter = datestring.split('-');
        return `${splitter[2]}/${splitter[1]}/${splitter[0]}`;
    }

    static datetimetoHHMM (datetimestring) {
        const daguur = datetimestring.split(' ');
        const splitter = daguur[1].split(':');
        return `${splitter[0]}:${splitter[1]}`;
    }

    static datetimetoDDMMYYYY (datetimestring) {
        const daguur = datetimestring.split(' ');
        const splitter = daguur[0].split('-');
        return `${splitter[2]}/${splitter[1]}/${splitter[0]}`;
    }

    static timetoHHMM (timestring) {
        const splitter = timestring.split(':');
        return `${splitter[0]}:${splitter[1]}`;
    }

    static getMinuten (timestring) {
        const splitter = timestring.split(':');
        return parseInt((splitter[0] * 60), 10) + parseInt(splitter[1], 10);
    }

    static getSeconden (timestring) {
        const splitter = timestring.split(':');
        return parseInt((splitter[0] * 60 * 60), 10)
            + parseInt(splitter[1] * 60, 10);
    }

    static datetoDMYVoluit (date) {
        const maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

        const dag = date.getDate();
        const maand = maanden[date.getMonth()];
        const jaar = date.getFullYear();
        return `${dag} ${maand} ${jaar}`;
    }

    static datetoMYVoluit (date) {
        const maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

        const maand = maanden[date.getMonth()];
        const jaar = date.getFullYear();
        return `${maand} ${jaar}`;
    }

    static datetoYVoluit (date) {
        const jaar = date.getFullYear();
        return `${jaar}`;
    }

    static stringdagVoluit (datestring) {
        const date = new Date(datestring);
        const dagen = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

        const dag = dagen[date.getDay()];
        return dag;
    }

    static maandVoluit (nummer) {
        const maanden = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
        return maanden[nummer - 1];
    }
}

export default DateFunctions;



// WEBPACK FOOTER //
// ./src/helpers/datefunctions.js